// src/components/InfoButton/GameRulesText.tsx
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GamesTranslations } from '../../locales/interfaces/games';

type GameRulesTextProps = {
  game: keyof GamesTranslations['rules'];
};

// Tytuł i punkty reguł gry z plików tłumaczeń (games:rules) — każdy RulesOfTheGame wstawia je w swój akapit
const GameRulesText: FC<GameRulesTextProps> = ({ game }) => {
  const { t } = useTranslation();
  // Punkty są w plikach tłumaczeń tablicą; returnObjects oddaje ją zamiast napisu
  const items = t(`games:rules.${game}.items`, { returnObjects: true }) as unknown as string[];

  return (
    <>
      <b>{t(`games:rules.${game}.title`)}</b>
      {items.map((item) => <li key={item}>{item}</li>)}
    </>
  );
};

export default GameRulesText;
